import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

// Defaults apontam para o app Browser "insurances-front" (account 7756548).
// Em prod os valores chegam via `.env` gerado no buildspec.yml; os fallbacks
// cobrem builds locais (`npm run build`) sem `.env.production`.
const licenseKey = import.meta.env.VITE_APP_NR_LICENSE_KEY ?? 'NRJS-aff38e996160b501b07';
const accountID = import.meta.env.VITE_APP_NR_ACCOUNT_ID ?? '7756548';
const trustKey = import.meta.env.VITE_APP_NR_TRUST_KEY ?? '7756548';
const agentID = import.meta.env.VITE_APP_NR_AGENT_ID ?? '601637409';
const applicationID = import.meta.env.VITE_APP_NR_APPLICATION_ID ?? '601637409';

const init = {
  session_replay: {
    enabled: true,
    block_selector: '',
    mask_text_selector: '*',
    sampling_rate: 10.0,
    error_sampling_rate: 100.0,
    mask_all_inputs: true,
    collect_fonts: true,
    inline_images: false,
    inline_stylesheet: true,
    mask_input_options: {},
  },
  distributed_tracing: { enabled: true },
  privacy: { cookies_enabled: true },
  ajax: { deny_list: ['bam.nr-data.net'] },
};

const info = {
  beacon: 'bam.nr-data.net',
  errorBeacon: 'bam.nr-data.net',
  licenseKey,
  applicationID,
  sa: 1,
};

const loader_config = {
  accountID,
  trustKey,
  agentID,
  licenseKey,
  applicationID,
};

// Singleton: instanciamos fora da factory para evitar múltiplos agentes.
// Sem licenseKey, `newrelic` fica null e todos os callers devem usar `?.`.
const newrelic = licenseKey
  ? new BrowserAgent({ init, info, loader_config })
  : null;

export function useNewRelic() {
  return { newrelic };
}
